import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      position="top-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#FF5A36] group-[.toaster]:text-white group-[.toaster]:border-[#E0492B] group-[.toaster]:shadow-lg group-[.toaster]:font-medium",
          description: "group-[.toast]:text-white/80",
          actionButton:
            "group-[.toast]:bg-white group-[.toast]:text-[#FF5A36]",
          cancelButton:
            "group-[.toast]:bg-white/20 group-[.toast]:text-white",
          success:
            "group-[.toaster]:bg-[#FF5A36] group-[.toaster]:text-white group-[.toaster]:border-[#E0492B]",
          error:
            "group-[.toaster]:bg-[#FF5A36] group-[.toaster]:text-white group-[.toaster]:border-[#E0492B]",
          warning:
            "group-[.toaster]:bg-[#FF5A36] group-[.toaster]:text-white group-[.toaster]:border-[#E0492B]",
          info:
            "group-[.toaster]:bg-[#FF5A36] group-[.toaster]:text-white group-[.toaster]:border-[#E0492B]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
